import { isApp, isAppIOS } from './tools';
import { getStatusBarHeight, customCall, customRegister, getVersion } from '@lhb/bridge';
// import { ReportForm } from '@/views/aproval/pages/create/ts-config';
// import { VideoInfo } from '@/views/aproval/pages/create/ts-config';
/**
 *
 * @returns {Number} 手机状态栏高度
 */
export function statusBarHeight() {
    return new Promise(function (resolve, reject) {
        if (!isApp()) { // 非app环境
            return resolve(0);
        }
        /**
         * 是否已拿到高度
         * 页面内存超限自动重刷时，桥接事件失效。这种特殊场景下能起到作用，避免页面顶部异常
         * */
        var gotHeight = false;
        setTimeout(function () {
            if (!gotHeight) {
                // 给默认高度，状态栏高度桥接事件一般20ms左右返回，这里设置时间稍微长些，没拿到就返回默认值
                resolve(44);
            }
        }, 100);
        var callBackFun = function (height) {
            if (+height > 0) {
                height = +height;
                resolve(height);
                gotHeight = true;
            }
            else {
                reject(0);
            }
        };
        if (isAppIOS()) { // 注意坑！lhb/bridge中使用的是getStatusBarHeight事件名，而ios用的是getStatusHeight事件名
            customCall('getStatusHeight', '', callBackFun);
        }
        else {
            getStatusBarHeight(callBackFun);
        }
    });
}
/**
 * 获取高德地图的经纬度
 * @returns Object {
 *   address: '' // 详细地址
 *   city: '' // 城市名
 *   lat: // 纬度
 *   lng: // 经度
 * }
 */
export function locationLngLat(params) {
    if (!isApp()) { // 非app环境
        throw new Error('非app环境，无法通过桥接获取经纬度，请在app环境内使用该桥接事件');
    }
    return new Promise(function (resolve, reject) {
        var timer = setTimeout(function () {
            reject("\u5B9A\u4F4D\u8D85\u65F6");
        }, 1500);
        var callBackFun = function (info) {
            clearTimeout(timer);
            if (info && typeof (info) === 'string') {
                resolve(JSON.parse(info));
            }
            else {
                params;
                // reject(params && params.openSystemPermission === 1 ? '开启定位权限失败' : `未获取到经纬度`);
                reject("\u672A\u83B7\u53D6\u5230\u7ECF\u7EAC\u5EA6");
            }
        };
        customCall('openMapLocation', '', callBackFun);
    });
}
/**
 * 选择图片/视频
 * params: {
    domain: '',
    bucket: '',
    token: ''
    accept: '', // video/* 任何视频文件 image/* 任何图片文件
    max-size: '', // 文件大小限制，单位为 byte
    max-count: ''	// 文件上传数量限制
  }
  @returns [
    {
      url: '',
      name: '',
      size: ''
    }
  ]
 */
export function chooseLocalPhoto(params) {
    return new Promise(function (resolve, reject) {
        if (!isApp())
            reject();
        var callBackFun = function (info) {
            if (info && typeof (info) === 'string') {
                resolve(JSON.parse(info));
            }
            else {
                reject();
            }
        };
        customCall('chooseLocalPhoto', params, callBackFun);
    });
}
export function getAfferentToken() {
    return new Promise(function (resolve, reject) {
        if (!isApp())
            reject();
        var callBackFun = function (info) {
            if (info && typeof (info) === 'string') {
                resolve(JSON.parse(info));
            }
            else {
                reject();
            }
        };
        customCall('getToken', {}, callBackFun);
    });
}
/*
  状态栏设置颜色（目前只支持切换文字颜色）
   * params: {
      isTextBlack: bool // true 黑字 false 白字
    }
*/
export function statusBarColor(params) {
    return new Promise(function (resolve, reject) {
        if (!isAppIOS())
            reject();
        var callBackFun = function (info) {
            if (info && typeof (info) === 'string') {
                resolve(JSON.parse(info));
            }
            else {
                reject();
            }
        };
        customCall('statusBarColor', params, callBackFun);
    });
}
// App 下载文件
export function appDownloadFile(url) {
    return new Promise(function (resolve, reject) {
        if (!isApp())
            reject();
        var callBackFun = function (info) {
            if (info && typeof (info) === 'string') {
                resolve(JSON.parse(info));
            }
            else {
                reject();
            }
        };
        customCall('downloadFile', url, callBackFun);
    });
}
// App 下载文件
export function appSaveImage(url) {
    return new Promise(function (resolve, reject) {
        if (!isApp())
            reject();
        var callBackFun = function (info) {
            if (info && typeof (info) === 'string') {
                resolve(JSON.parse(info));
            }
            else {
                reject();
            }
        };
        customCall('saveImage', url, callBackFun);
    });
}
// App 预览文件（预览pdf）
export function appPreviewFile(url) {
    return new Promise(function (resolve, reject) {
        if (!isApp())
            reject();
        var callBackFun = function (info) {
            if (info && typeof (info) === 'string') {
                resolve(JSON.parse(info));
            }
            else {
                reject();
            }
        };
        customCall('previewFile', url, callBackFun);
    });
}
// 复制到剪切板
export function copyToClipboard(text) {
    return new Promise(function (resolve, reject) {
        if (!isApp())
            reject();
        var callBackFun = function (info) {
            if (info) {
                resolve(typeof (info) === 'string' ? JSON.parse(info) : true);
            }
            else {
                reject();
            }
        };
        customCall('pasteboard', text, callBackFun);
    });
}
// 唤起第三方应用
export function openSocialApp() {
    return new Promise(function (resolve, reject) {
        if (!isApp())
            reject();
        var callBackFun = function (info) {
            if (info) {
                resolve(typeof (info) === 'string' ? JSON.parse(info) : true);
            }
            else {
                reject();
            }
        };
        customCall('openSocialApp', '', callBackFun);
    });
}
/**
 * 打开微信客服
 */
export function jumpWechatService() {
    return new Promise(function (resolve, reject) {
        if (!isApp())
            reject('非APP环境内，无法唤起微信');
        customCall('service', '', function () { return resolve(true); });
    });
}
/**
 * 刷新H5
 */
export function refreshH5(callFn) {
    return new Promise(function (resolve, reject) {
        if (!isApp())
            reject('非APP环境内，无法调用刷新事件');
        // const callBackFun = () => (resolve(true));
        customRegister('refreshH5', callFn);
    });
}
/**
 *
 * @returns {String} App版本号
 */
export function getAppVersion() {
    return new Promise(function (resolve) {
        if (!isApp()) { // 非app环境
            return resolve(0);
        }
        var callBackFun = function (version) {
            resolve(version);
        };
        if (isAppIOS()) { // 注意坑！lhb/bridge中使用的是getVersion事件名，而ios用的是appVersion事件名
            customCall('appVersion', '', callBackFun);
        }
        else {
            getVersion(callBackFun);
        }
    });
}
// 支持使用上传文件组件的安卓app版本号
export var uploadOfAndroidAppVersion = 2.53;
/**
 * 安卓 上传文件
 */
export function uploadFileOfAndroid(params) {
    // console.log('uploadFileOfAndroid', params);
    return new Promise(function (resolve, reject) {
        if (!isApp()) { // 非app环境
            return resolve(0);
        }
        var callBackFun = function (res) {
            if (res && typeof (res) === 'string') {
                var targetRes = JSON.parse(res);
                /*
                  回调参数为json，内容如下
                  成功时
                  {
                    type: 'success',
                    value: [{url: 'XXXX', name: 'name1'}, {url: 'XXXX', name: 'name2'}, ]
                    remark: '额外说明文字'
                  }
        
                  失败时
                  {
                    type: 'fail',
                    value: '这是失败原因'
                  }
        
                  取消时
                  {
                    type: 'cancel',
                    value: null
                  }
                */
                var _a = targetRes || {}, type = _a.type, value = _a.value;
                if (type === 'fail') {
                    reject(value);
                }
                else {
                    resolve(targetRes);
                }
            }
            else {
                reject("uploadFiles \u6865\u63A5\u4E8B\u4EF6\u8FD4\u56DE\u6570\u636E\u4E0D\u5408\u6CD5");
            }
        };
        customCall('uploadFiles', params, callBackFun);
    });
}
export var uploadVideoOfIOSVersion = 2.45;
/**
 * ios 上传视频
 */
export function uploadVideoOfIOS(params) {
    return new Promise(function (resolve, reject) {
        if (!isApp()) { // 非app环境
            return resolve(0);
        }
        var callBackFun = function (res) {
            if (res && typeof (res) === 'string') {
                var targetRes = JSON.parse(res);
                /*
                  回调参数为json，内容如下
                  成功时
                  {
                    type: 'success',
                    value: [{url: 'XXXX', name: 'name1'}, {url: 'XXXX', name: 'name2'}, ]
                  }
        
                  失败时
                  {
                    type: 'fail',
                    value: '这是失败原因'
                  }
        
                  取消时
                  {
                    type: 'cancel',
                    value: null
                  }
                */
                var _a = targetRes || {}, type = _a.type, value = _a.value;
                if (type === 'fail') {
                    reject(value);
                }
                else {
                    resolve(targetRes);
                }
            }
            else {
                reject("ios uploadVideos \u6865\u63A5\u4E8B\u4EF6\u8FD4\u56DE\u6570\u636E\u4E0D\u5408\u6CD5");
            }
        };
        customCall('uploadVideos', params, callBackFun);
    });
}
